import { Note } from 'domain';

const get = (noteId) => {
    const query = new Parse.Query(Note)
        .include(['type', 'observation']);
    
    return {
        type: 'GET_NOTE',
        meta: { noteId },
        payload: query.get(noteId)
    };
};

const list = (filters = {}) => {
    const query = new Parse.Query(Note)
        .include(['type', 'observation', 'location']);

    if (filters.observation) {
        query.equalTo('observation', filters.observation);
    }
    
    if (filters.location) {
        query.equalTo('location', filters.location);
    }

    return {
        type: 'LIST_NOTE',
        meta: { filters },
        payload: query.find()
    };
};

const save = (note) => {
    const noteToSave = note.id ? new Note({ id: note.id }) : new Note();
    noteToSave.set('type', { 
        __type: 'Pointer', 
        className: 'NoteType', 
        objectId: note.type 
    });
    
    if (note.observation) {
        noteToSave.set('observation', { 
            __type: 'Pointer', 
            className: 'Observation', 
            objectId: note.observation 
        });
    }
    
    if (note.location) {
        noteToSave.set('location', { 
            __type: 'Pointer', 
            className: 'Location', 
            objectId: note.location 
        });
    }
    
    noteToSave.set('date', note.date);
    noteToSave.set('text', note.text);
    return {
        type: 'SAVE_NOTE',
        payload: noteToSave.save()
    };
};

const update = (noteId, noteData) => {
    const noteToUpdate = new Note({ id: noteId });
    noteToUpdate.set('type', { 
        __type: 'Pointer', 
        className: 'NoteType', 
        objectId: noteData.type 
    });
    
    if (noteData.observation) {
        noteToUpdate.set('observation', { 
            __type: 'Pointer', 
            className: 'Observation', 
            objectId: noteData.observation 
        });
    }
    
    if (noteData.location) {
        noteToUpdate.set('location', { 
            __type: 'Pointer', 
            className: 'Location', 
            objectId: noteData.location 
        });
    }
    
    noteToUpdate.set('date', noteData.date);
    noteToUpdate.set('text', noteData.text);
    return {
        type: 'UPDATE_NOTE',
        payload: noteToUpdate.save()
    };
};

const remove = (noteId) => {
    const noteToDelete = new Note({ id: noteId });
    return {
        type: 'DELETE_NOTE',
        payload: noteToDelete.destroy()
    };
};

export default {
    get,
    list,
    save,
    update,
    remove
};